import React from 'react';
import ImageLogo from 'assets/images/svg/logo.svg';
import { Link } from 'react-router-dom';
import './header.scss';
import ButtonHelp from 'components/button-help';
import ROUTES from 'libs/constants/routes';

interface IHeaderProps {
  isMirrorPage: boolean;
}

export const Header: React.FC<IHeaderProps> = ({ isMirrorPage }) => (
  <div className="header-quote">
    <div className="content-header">
      <Link to={isMirrorPage ? ROUTES.LANDING_MIRROW : ROUTES.LANDING}>
        <img className="logo" src={ImageLogo} alt="logo" />
      </Link>
      <ButtonHelp />
    </div>
  </div>
);
